<template>
    <div class="pack-box gift-choice">
        <div class="pack-title">
            <img src="/images/fr_new_home/cadeau.svg" alt="cadeaux"/>
            <h3> Choisissez votre <span class="orange-text">cadeau</span></h3>
        </div>
        <h6 class="text-uppercase orange-text">Accédez à un catalogue complet de cadeaux</h6>
        <p>
            Le consommateur devrait toujours avoir le choix. C’est pourquoi, Test
            Achats vous propose de choisir parmi un catalogue de cadeaux variés&nbsp;:
        </p>
        <ul>
            <li>High-Tech</li>
            <li>Beauté & Bien-être</li>
            <li>Maroquinerie & bijoux</li>
            <li>Brico & jardin</li>
            <li>Petits électroménagers</li>
            <li>Déco & art de la table</li>
            <li>Cartes cadeaux</li>
            <li>…</li>
        </ul>


    </div>
</template>

<script>
import ScrollLink from "../_commons/fr/ScrollLink.vue";

export default {
    components: { ScrollLink},
}
</script>

